import React from "react";
import BaseDialog from "./BaseDialog";

export default function ComfirmDialog(props) {
  const {
    open,
    title,
    contents,
    buttonText = "확인",
    onClick,
  } = props;

  return (
    <BaseDialog
      open={open}
      title={title}
      content={contents}
      actionType="single"
      singleButtonText={buttonText}
      onSingleClick={onClick}
    />
  );
}
